module.exports = __webpack_public_path__ + "img/base_img_doctor.73f0e56d.webp";